<template>
  <div
    v-click-outside="close"
    @click="toggleMenu"
  >
    <div
      ref="element"
      class="user-mini-card d-flex"
      :style="actModal ? 'border: 1px solid #E2E2E2 !important;':''"
      :class="browserClass"
      @click="toggle"
    >
      <!-- <div class="user-mini-card__howdy" /> -->
      <base-text
        class="company"
        size="m"
        light
      />
      <base-avatar
        class="user-mini-card__avatar"
        :inverse="adminOptions()"
        :size="36"
        rounded-image
        :username="username"
        :background-color="admin() ? '#333' : '#e9ad7d'"
      />
      <span style="align-self: center; margin-left: 7px;">
        <!-- {{ name }} -->
        {{ adminOptions() ? "Admin" : "Stylist" }}
      </span>
      <base-icon style="margin: 0 10px 0 15px;" :icon="actModal ? 'caret-up-black' : 'caret-down-black'" />
    </div>
    <div
      ref="tooltip"
      class="user-mini-card__options"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core';
import BaseAvatar from '@/components/Base/BaseAvatar';
import WhichBrowser from './mixins/whichbrowser';

export default {
  name: 'UserMiniCard',
  components: { BaseAvatar },
  mixins: [WhichBrowser],
  props: {
    username: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    version: {
      type: String,
      default: '',
    },
    closeMiniCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      instance: null,
      element: '',
      tooltip: '',
      actModal: false,
    };
  },
  watch: {
    closeMiniCard(close) {
      if (close) {
        this.$emit('cardClosed');
        this.close();
      }
    },
  },
  mounted() {
    this.element = this.$refs.element;
    this.tooltip = this.$refs.tooltip;

    this.instance = createPopper(this.element, this.tooltip, {
      placement: 'bottom-end',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5],
          },
        },
      ],
    });
  },
  methods: {
    isManager() {
      const role = this.user ? this.user.profile.role : this.role;
      return role.includes('manager');
    },
    adminOptions() {
      return this.$store.state.account.isAdminMode;
    },
    admin() {
      if (this.isManager && this.adminOptions()) {
        return true;
      }
      return false;
    },
    toggle() {
      if (!this.isIPad) {
        return;
      }
      this.instance.update(); // Refreshes the position

      if (!this.tooltip.hasAttribute('data-show')) {
        this.tooltip.setAttribute('data-show', '');
      } else {
        this.actModal = false;
        this.tooltip.removeAttribute('data-show');
      }
    },
    close() {
      this.actModal = false;
      this.tooltip.removeAttribute('data-show');
    },
    toggleMenu() {
      if (this.isIPad) {
        return;
      }

      if (!this.tooltip.hasAttribute('data-show')) {
        this.actModal = true;
        this.tooltip.setAttribute('data-show', '');
      } else {
        this.actModal = false;
        this.tooltip.removeAttribute('data-show');
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.user-mini-card {
  border: 1px solid transparent !important;
  margin-top: 8px !important;
  margin-left: 15px;
  padding: 4px 5px 4px 5px;
  border-radius: 6px;
  width: 140px;
  display: flex-end;
  justify-content: space-between;
  align-items: stretch;
  cursor: pointer;
  color: #646464;

  &--condensed{
    min-width: inherit;
  }

  &__howdy{
    font-family: $font-family-sans-serif-medium;
    font-size: 12px;
    line-height: 14px;
    text-align: right;
    margin-right: 10px;
    color: $black;

    @media (min-width: map-get($breakpoints,'lg')) {
      display: none;
    }
  }

  &__icon {
    margin-left: 5px;
    @media (min-width: map-get($breakpoints,'lg')) {
      display: none;
    }
  }

  .company{
    margin-right: 0.625rem;
    display: none;

    @media (min-width: map-get($breakpoints,'lg')) {
      display: block;
    }
  }

  &::v-deep .company.base-text {
    line-height: 26px;
    font-weight: 300;
    letter-spacing: 0.35px;
    display:none;
  }

  &::v-deep .vue-avatar--wrapper > span {
  }

  &__options {
    background-color: #FFF;
    box-shadow: 0px 12px 12px -6px rgba(51, 51, 51, 0.16);
    border-radius: 4px;
    width:315px !important;
    max-height: 174px !important;
    margin: unset !important;
    margin-top: 10px !important;
    margin-left: 10px !important;
    font-size: 13px;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;

    &[data-show] {
      opacity: 1 !important;
      pointer-events: inherit;
    }

    #outer {
      position: absolute;
      top: -15%;
      left: 81%;
      width: 11%;
      height: 24%;
      overflow: hidden;
      transform: rotate(-90deg);
    }

     .tooltip__arrow{
        transform: rotate(45deg);
        background-color: white;
        width: 33px;
        height: 100px;
        top: 3px;
        left: -45px;
        position: relative;
        border-radius: 6px;
        box-shadow: 1px 1px 3px 1px rgb(128 128 128 / 5%);
     }

    &[data-popper-placement^="left"] > .tooltip__arrow {
      right: -4px;
    }

    &[data-popper-placement^="right"] > .tooltip__arrow {
      left: -4px;
    }
  }
}
.user-mini-card:hover {
    border: 1px solid #E2E2E2 !important;
}

::v-deep .base-cell {
  border-top: 1px solid #ccc;
  min-height: unset;
}

.version{
  display: block;
  text-align: right;
  font-size: 0.6rem;
  opacity: 0.3;
  line-height: 0;
  margin-top: -5px;
  padding-bottom: 10px;
}
</style>
